// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for GET /so/products/lista — returns the list of products.
 */
import type { Products_ListRow } from './Products_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Products_ListaResponseDados = Products_ListRow[];

export type Products_ListaResponse = ApiResponse<Products_ListaResponseDados>;

registerResponseContract('Products_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_product_id:                          { type: 'number',  required: true },
      so_product_category_id:                 { type: 'number',  required: true },
      so_product_name:                        { type: 'string',  required: true },
      so_product_description:                 { type: 'string',  required: false },
      so_product_default_price:               { type: 'number',  required: false },
      so_product_sku:                         { type: 'string',  required: false },
      so_product_unit_of_measure:             { type: 'string',  required: false },
      so_product_track_stock:                 { type: 'number',  required: false },
      so_product_franchise_id:                { type: 'number',  required: false },
      so_product_active:                      { type: 'number',  required: false },
      so_product_created_at:                  { type: 'string',  required: false },
      so_product_additional_deadline_days:    { type: 'number',  required: false },
      so_product_category_name:               { type: 'string',  required: false },
      so_product_franchise_name:              { type: 'string',  required: false },
      so_product_primary_image_thumbnail_url: { type: 'string',  required: false },
      so_product_available_quantity:          { type: 'number',  required: false },
    },
  },
})
